import { useTranslation } from 'react-i18next';
import { Modal } from 'reactstrap';
import { useState, useEffect } from 'react';
import { classes } from './modalClasses'; // Assuming you have a similar styles object
import { Feedback } from '@mui/icons-material';

export const FeedbackModalShow = (props) => {
    const { t } = useTranslation();
    const [modalOpen, setModalOpen] = useState(false);


    const [feedbackArray, setFeedbackArray] = useState([]); // Array to store domains and commentaries
    const [currentPage, setCurrentPage] = useState(1); // Current page for pagination
    const rowsPerPage = 5; // Number of rows per page

    const handleModalClose = () => {
        setModalOpen(false);
        setCurrentPage(1)
        props.handleClose();
    };




    const totalPages = Math.ceil(feedbackArray.length / rowsPerPage);
    const paginatedRows = feedbackArray.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );
    useEffect(() => {
        if (props.open) {
            setModalOpen(true);
        }
    }, [props.open]);


    useEffect(() => {
        if (props.array) {
            const normalize = (r) => (r ?? '').replace(/^ROLE_/, '').toUpperCase();
            const currentRole = normalize(props.role);

            const scoped = props.array
                .map((item) => {
                    const ownComments = (item.feedbacksList ?? [])
                        .filter((fb) => normalize(fb.authorRole) === currentRole)
                        .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
                    return { ...item, ownComments };
                })
                .filter((item) => item.ownComments.length > 0);

            setFeedbackArray(scoped);
        }
    }, [props.array, props.role]);



    function updateCommantary(itemId, value) {
        const sortedupdatedItems = feedbackArray.map((item) => {
            if (item.netlinking.id === itemId) {
                return { ...item, feedback: value };
            }

            return item;
        });
        setFeedbackArray(sortedupdatedItems)

    }


    return (
        <Modal
            style={classes.superLargeModalCustom}
            isOpen={props.open}
            toggle={handleModalClose}
            backdrop={true}
            keyboard={false}
        >
            <div style={classes.modalHeader} className="modal-header">
                <h5 style={classes.title} className="modal-title">
                    {t('Commentaire')}
                </h5>
                <button
                    type="button"
                    onClick={handleModalClose}
                    style={classes.btnClose}
                    className="btn-close"
                    aria-label="Close"
                />
            </div>
            <div style={classes.modalPad} className="modal-body">
                <div className="row row-mb-lg">
                    <div className="col-12">
                        <p style={classes.textConfirm}>{t('Vos commentaires nous intéressent !')}</p>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center", // Centers horizontally
                        }}
                    >
                        <img
                            style={{
                                height: '150px'
                            }}
                            src="/Images/chicken/feedbackStress.gif"
                            alt="download icon"
                        />
                    </div>

                </div>
                {/* Table to Display Feedback Array */}
                <div className="table-responsive">
                    <div className="box-table-netlinking">
                        <table className="table-lists">
                            <thead>
                                <tr>
                                    <th>{t('Domaine')}</th>
                                    <th>{t('Commentaire')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedRows.map((item, index) => (
                                    <tr key={item.netlinking.id}>
                                        <td>{item.netlinking.domain}</td>
                                        <td>
                                            {item.ownComments.map((fb, i) => (
                                                <div
                                                    key={fb.id ?? i}
                                                    style={{
                                                        marginBottom: i < item.ownComments.length - 1 ? 8 : 0,
                                                        padding: '6px 8px',
                                                        border: '1px solid #eee',
                                                        borderRadius: 4,
                                                    }}
                                                >
                                                    {fb.comment}
                                                </div>
                                            ))}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                {/* Pagination Controls */}
                {totalPages > 1 && (
                    <>
                        <div className="box-pagination">
                            {feedbackArray.length === 0 || currentPage === 1 ? (
                                <div style={{ cursor: 'not-allowed' }} className="text-page">
                                    {t('Précédent')}
                                </div>
                            ) : (
                                <div
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setCurrentPage(currentPage - 1)}
                                >
                                    {t('Précédent')}
                                </div>
                            )}

                            <div className="list-page-number">
                                {
                                    <span
                                        className={'active'}
                                    >
                                        {currentPage}
                                    </span>
                                }
                                {feedbackArray.length === 0 ||
                                    currentPage === Math.ceil(feedbackArray.length / 5) ? (
                                    <span style={{ cursor: 'not-allowed' }} className="text-page">
                                        {t('Suivant')}
                                    </span>
                                ) : (
                                    <span onClick={() => setCurrentPage(currentPage + 1)}>
                                        {t('Suivant')}
                                    </span>
                                )}
                            </div>
                        </div>
                    </>
                )}
            </div>
        </Modal>
    );
};

export default FeedbackModalShow;
